/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrerrorcorrectionm3Inputs */

const en_qrerrorcorrectionm3 = /** @type {(inputs: Qrerrorcorrectionm3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medium`)
};

const de_qrerrorcorrectionm3 = /** @type {(inputs: Qrerrorcorrectionm3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittel`)
};

/**
* | output |
* | --- |
* | "Medium" |
*
* @param {Qrerrorcorrectionm3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrerrorcorrectionm3 = /** @type {((inputs?: Qrerrorcorrectionm3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrerrorcorrectionm3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrerrorcorrectionm3(inputs)
	return de_qrerrorcorrectionm3(inputs)
});
export { qrerrorcorrectionm3 as "qrErrorCorrectionM" }